import './StepCircle.style.scss';

export function StepCircle({ step }: { step: string }) {
  return <div className="case-step-circle">{step}</div>;
}
